import { html } from '@effectivastudio/lit-components';
import DotMenu from '@effectivastudio/lit-components/components/dot_menu/element.js';
import DotMenu2 from '@effectivastudio/lit-components/components/dot_menu_2/element.js';

DotMenu.prototype.renderTrigger = function renderTrigger() {
  return html`
    <button class=${this.buttonClass || 'bu-btn btn-contrast-light'}>
      <bu-icon name="ellipsis-vertical"></bu-icon>
    </button>
  `;
};

DotMenu2.prototype.renderTrigger = function renderTrigger() {
  return html`
    <button class=${this.buttonClass || 'bu-btn btn-contrast-light'}>
      <bu-icon name="ellipsis-vertical"></bu-icon>
    </button>
  `;
};
